import Banner from './Banner';

function BannerSection(props: {
  title: string;
  description?: string;
  contactButton?: boolean;
  imageUrl: string;
  bigCard?: boolean;
}) {
  return (
    <section className="h-[480px] md:h-[500px] lg:h-[570px] xl:h-[590px]">
      <Banner {...props} />
    </section>
  );
}

export default BannerSection;
